import { RouteType } from 'types/RouteType';
import { ServiceStoreType } from 'types/ServiceStoreTypes';
// import DepartmentsIcon from '@mui/icons-material/SupervisedUserCircle';

const departmentsRoute: RouteType = {
  name: 'Departments',
  path: '/departments',
  layout: '/app',
  viewportCard: {
    header: {
      title: 'Departments',
      enableRefreshButton: true,
      enableBackButton: true,
      // If Dashboard.Header exists, import and use it here
      // component: () => import('./Departments.Header'),
    },
    body: {
      // component: () => import('./Departments.Body'),
      gridContainer: {
        namespace: 'DepartmentsDataGrid',
        storeName: 'departmentTeamsStore',
        // customEntity: 'qrCodeRows',
        // fixedRowCount: 2,
        columnHeaders: [
          {
            width: 200,
            title: 'Name',
            key: 'departmentName',
          },
          {
            width: 200,
            title: 'Team',
            key: 'teamName',
          },
        ],
        defaultSort: {
          sortBy: ['departmentName'],
          sortDirection: { departmentName: 'ASC' },
        },
        enableInlineEdit: true,
        enableHover: true,
        onSubmitEdits: (id, data, rootStore) => {
          console.log('onSubmitEdits', id, data, rootStore);
          const departmentTeamsStore =
            rootStore.departmentTeamsStore as ServiceStoreType;
          departmentTeamsStore.patch(Number(id), data as object);
        },
      },
    },
  },
  group: 'Administration',
  requiresAuth: true, // Assuming this based on requiresPermission: false in original. May need to be confirmed.
  requiresPermission: false,
  requiresAdmin: true,
  channels: ['departments', 'department-teams'],
  enableAutoFind: true,
  // Transferring properties from the old format, although they might not be directly compatible.

  hidden: false, //  This might need to be handled differently in the new structure potentially through conditional rendering in a sidebar component.
};

export default departmentsRoute;
